"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayApiInfoModal = void 0;
const api_1 = require("client/api");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const text_field_1 = require("client/components/material/text-field");
const Visibility_1 = require("material-ui-icons/Visibility");
const VisibilityOff_1 = require("material-ui-icons/VisibilityOff");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
require("./gateway-api-info-modal.less");
/**
 * Dev-only CardPointe Gateway Basic Auth credentials for one pharmacy's MID.
 * The saved password never leaves the server, so the field starts empty and an
 * empty submit keeps whatever is already stored.
 */
let GatewayApiInfoModal = class GatewayApiInfoModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.saving = false;
        this.username = "";
        this.password = "";
        /** A password is stored for this MID, so this open is an update, not a first add. */
        this.hasStoredPassword = false;
        this.showPassword = false;
        this.error = "";
        this.load = async () => {
            this.loading = true;
            this.error = "";
            const result = await api_1.PaymentEndpoint.readSiteCardConnectGatewayCredentials.apiCall(null, { siteId: this.props.siteId });
            this.loading = false;
            if (api_1.isError(result)) {
                this.error =
                    result.errProp ||
                        result.code ||
                        "Unable to load the saved credentials.";
                return;
            }
            this.username =
                result.credentials.gatewayApiUsername ||
                    result.credentials.defaultGatewayApiUsername;
            this.hasStoredPassword = result.credentials.hasGatewayApiPassword;
        };
        this.onSave = async () => {
            if (!this.username.trim()) {
                this.error = "Username is required.";
                return;
            }
            if (!this.password && !this.hasStoredPassword) {
                this.error = "Password is required.";
                return;
            }
            this.saving = true;
            this.error = "";
            const result = await api_1.PaymentEndpoint.saveSiteCardConnectGatewayCredentials.apiCall(null, {
                credentials: {
                    siteId: this.props.siteId,
                    gatewayApiUsername: this.username,
                    gatewayApiPassword: this.password || undefined
                }
            });
            this.saving = false;
            if (api_1.isError(result)) {
                this.error =
                    result.errProp ||
                        result.code ||
                        "Unable to save the credentials.";
                return;
            }
            this.props.onSaved(!!result.credentials.gatewayApiUsername &&
                result.credentials.hasGatewayApiPassword);
        };
        this.onCancel = () => {
            if (this.saving)
                return;
            this.props.onCancel();
        };
        this.setUsername = (_event, value) => {
            this.username = value;
            this.error = "";
        };
        this.setPassword = (_event, value) => {
            this.password = value;
            this.error = "";
        };
        this.togglePassword = () => {
            this.showPassword = !this.showPassword;
        };
    }
    componentDidMount() {
        this.load();
    }
    render() {
        const busy = this.loading || this.saving;
        const mid = this.props.gatewayMid
            ? `MID ${this.props.gatewayMid}`
            : "this pharmacy’s MID";
        return (React.createElement(confirmation_modal_1.ConfirmationModal, { title: "CardPointe API credentials", message: `Authorizes card payments for ${mid}. CardPointe issues these once the merchant is boarded.`, confirmText: this.saving ? "Saving…" : "Save credentials", cancelText: "Cancel", shouldDisableConfirm: busy ||
                !this.username.trim() ||
                (!this.password && !this.hasStoredPassword), addinModal: React.createElement("div", { className: "gateway-api-info" },
                React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Username", value: this.username, disabled: busy, inputProps: { maxLength: 128 }, onChange: this.setUsername }),
                React.createElement(text_field_1.MaterialTextField, { label: this.hasStoredPassword ? "New password" : "Password", type: this.showPassword ? "text" : "password", value: this.password, disabled: busy, inputProps: { maxLength: 255 }, newPasswordField: true, rightItem: React.createElement("button", { type: "button", className: "gateway-api-info__eye", "aria-label": this.showPassword ? "Hide password" : "Show password", disabled: !this.password, onClick: this.togglePassword }, this.showPassword ? (React.createElement(VisibilityOff_1.default, null)) : (React.createElement(Visibility_1.default, null))), onChange: this.setPassword }),
                React.createElement("p", { className: "gateway-api-info__status" }, this.hasStoredPassword && !this.password
                    ? "Leave blank to keep the saved password."
                    : ""),
                this.error && (React.createElement("p", { className: "gateway-api-info__error" }, this.error))), onCancel: this.onCancel, onConfirm: this.onSave }));
    }
};
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "saving", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "username", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "password", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "hasStoredPassword", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "showPassword", void 0);
__decorate([
    mobx_1.observable
], GatewayApiInfoModal.prototype, "error", void 0);
GatewayApiInfoModal = __decorate([
    mobx_react_1.observer
], GatewayApiInfoModal);
exports.GatewayApiInfoModal = GatewayApiInfoModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/financial/components/gateway-api-info-modal/gateway-api-info-modal.tsx
// module id = 4034
// module chunks = 0